export default __webpack_public_path__ + "static/media/Validações (Real Size).dab9a833.svg";